import { DefaultThemeOptions, FormsFeature, ThemeName } from "@ngt/forms";
import * as dtos from '@/api/dtos';
import logo from '@/assets/img/logo-small.png';
import { responsiveFontSizes } from "@mui/material";
import { grey } from "@mui/material/colors";
import { parse } from "qs";

const primaryColorLight = '#562c85';
const secondaryColorLight = '#e8078c';
const primaryColorDark = '#7d6699';
const secondaryColorDark = '#a44b80';
const primaryColorMoreDark = '#584b66';
const secondaryColorMoreDark = '#99567e';

const queryParams = parse(location.search, { ignoreQueryPrefix: true });
let override: string = (queryParams.theme ?? queryParams.Theme) as string;

const overrideTheme: ThemeName | undefined = override === 'dark' || override === 'light' ? override as ThemeName : undefined;

if (overrideTheme) {
    localStorage.setItem("theme", `"${overrideTheme}"`);
}

const formsFeature = new FormsFeature({
    dtos,
    baseRoute: '/participant-data',
    extensions: [

    ],
    organisationOptions: {
        organisationName: 'Breast Cancer Trials',
        organisationLogo: logo
    },
    client: {
        baseUrl: import.meta.env.VITE_API_URL,
        basePath: '/api',
        client: undefined
    },
    themeOptions: {
        beforeThemeCreated: (themeOptions, chosenTheme) => {
            const newOptions = {
                ...themeOptions,
                palette: {
                    ...themeOptions.palette,
                    primary: {
                        main: chosenTheme === 'dark' ? primaryColorDark : primaryColorLight
                    },
                    secondary: {
                        main: chosenTheme === 'dark' ? secondaryColorMoreDark : secondaryColorLight 
                    }
                }
            };

            if (chosenTheme !== 'dark') {
                newOptions.palette.background = {
                    default: grey[200]
                }
            }

            return newOptions;
        },
        afterThemeCreated: (theme, chosenTheme) => {
            return responsiveFontSizes(theme);
        },
        themeOptions: DefaultThemeOptions
    },
    initialAuthentication: (window as any).AUTH,
    initialFormMetadata: (window as any).FORM_METADATA, 
    initialMetadataTypes: (window as any).METADATA_TYPES
});


export default formsFeature;